import { Component, Input, OnInit, Renderer2, ViewChild } from "@angular/core";
import {
  NgbActiveModal,
  NgbDateStruct,
  NgbCalendar,
  NgbDatepicker,
} from "@ng-bootstrap/ng-bootstrap";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import { tBookingService } from "src/app/services/tBooking.service";
import { Calendar } from "@fullcalendar/core";
import { FullCalendarComponent } from "@fullcalendar/angular";
import * as dataJson from "../../../assets/config/bookingCalendarConfig.json";
import { HttpClient } from "@angular/common/http";
import twLocale from "@fullcalendar/core/locales/zh-tw";
import { TranslateService } from "@ngx-translate/core";
import { tEmployeeModel } from "src/app/models/tEmployeeModel";
export class BookingCalendarData {
  bkBookedDate: String;
  bookingTime: String;
  bookings: number;
  patients: String[];
}

@Component({
  selector: "app-booking-calendar-dialog",
  templateUrl: "./booking-calendar-dialog.component.html",
  styleUrls: ["./booking-calendar-dialog.component.css"],
})
export class BookingCalendarDialogComponent implements OnInit {

  @Input() selectedDoctor: tEmployeeModel;

  @ViewChild("calendar")
  calendarComponent: FullCalendarComponent;
  @ViewChild("dp") dpComponent: NgbDatepicker;

  TAG = "BookingCalendarDialogComponent";
  calendarPlugins = [timeGridPlugin, dayGridPlugin];
  calendarEvents = [];
  calendarEventColor = "#3b5998";
  calendarEventTextColor = "white";
  calendarLocales = [twLocale];
  calendarMinTime = "09:30:00";
  calendarMaxTime = "10:00:00";
  calendarHeader = { right: "" };
  //calendarHeader = { center: "dayGridMonth,timeGridWeek" , right: 'prev,next'};
  calendarButtonText = { today: "今天", week: "週", month: "月" };
  calendarApi: Calendar;
  bookingTimeSlot_max_limit = 0;
  calendarCustomButtons = {};

  NgbDateModel: NgbDateStruct;
  date: { year: number; month: number };

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private bookingService: tBookingService,
    private Ngb_Calendar: NgbCalendar,
    private translateServcie: TranslateService
  ) {
    const res = (dataJson as any).default;

    if (res.bookingTimeSlot_max_limit != null) {
      this.bookingTimeSlot_max_limit = res.bookingTimeSlot_max_limit;
      console.log(
        "bookingTimeSlot_max_limit = " + res.bookingTimeSlot_max_limit
      );
    }
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.setCalendarTimeSlot();
    this.setCalendarEvents();
    this.today();

  }

  /**
   * Convert Date to string. 1-9 convert to 0+(1-9)
   * @param number
   * @returns Eg. 1=>01 , 11 => 11;
   */
  converterDate_addZero_to_less_than_10(number) {
    if (number >= 10) return number;
    return "0" + number;
  }

  /**
   * set calendar current date
   */
  today() {
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.today();

    this.dpComponent.navigateTo(); //* set datepicker to current Year and current month 1
    this.NgbDateModel = this.Ngb_Calendar.getToday(); //* set datepicker to current day 2
  }

  dateSelect(event) {
    console.log("dateSelect event = " + JSON.stringify(event));
    console.log("dateSelect hi");
    let date = event.year;

    date += "-" + this.converterDate_addZero_to_less_than_10(event.month);
    date += "-" + this.converterDate_addZero_to_less_than_10(event.day);

    let calendarApi = this.calendarComponent.getApi();

    console.log("selected date = " + date.toString());
    calendarApi.changeView("timeGridWeek", date);
  }

  dayClick(event) {
    console.log("dayClick = " + this.calendarApi);

    this.date = event.next;
  }

  change(event){
    console.log('datepicker date change = '+ JSON.stringify(event));
    let date = event.year;
    date += "-" + this.converterDate_addZero_to_less_than_10(event.month);
    date += "-" + this.converterDate_addZero_to_less_than_10(event.day);

    let calendarApi = this.calendarComponent.getApi();
    calendarApi.changeView("timeGridWeek", date);
  }

  translate(word, value?) {
    let result = "";
    if (value != null) {
      this.translateServcie.get(word, value).subscribe((res: string) => {
        result = res;
      });
    } else {
      this.translateServcie.get(word).subscribe((res: string) => {
        result = res;
      });
    }

    return result;
  }

  /**
   *
   * @param date eg.2022-08-31
   * @param time eg.12:30
   * @returns eg.2022-08-31T12:30:00
   */
  dateConverter_ISO8601(date, time) {
    //* EXCEPT: "2022-08-31T12:30:00"
    return date + "T" + time + ":00";
  }

  eventHover() {
    // console.log('hi event Hover');
  }

  space() {
    return " ";
  }

  patientNames(patientNames: String[]) {
    var res = '';

    for(var i=0; i<patientNames.length; i++){
      res += patientNames[i] + this.space();
      if (i == 4) {
        res += '...';
        break;
      }
      res += ','
    }
    return res;
  }

  //* convert bookings to calendar events
  setCalendarEvents() {
    // console.log("do setCalendarEvents");
    var events = [];

    const api = this.selectedDoctor
    ? this.bookingService.getBookingForCalendarByEmployeeID(
      this.selectedDoctor.employeeID
    ):
    this.bookingService.getBookingForCalendar()
    ;

    //* call booking service , request shopID = currentShopID and start from today booking.
    api.subscribe((data) => {
      //console.log("getBookingForCalendar() = " + data.toString());
      data.forEach((data1) => {
        var event = {
          // title: this.translate('BookingCalendar.EventBookingTitle',{qty:data1.bookings}) + '\n 病人名稱---病人服務 '+ '\n 病人名稱---病人服務 ' + '...',
          title:
            this.translate("BookingCalendar.EventBookingTitle", {
              qty: data1.bookings,
            }) +
            "\n" +
            this.patientNames(data1.patients),
          date: this.dateConverter_ISO8601(
            data1.bkBookedDate,
            data1.bookingTime
          ), //* EXCEPT: "2022-08-31T12:30:00"
          color: this.isBookingFull(data1.bookings),
          //eventMouseEnter:function(event){console.log('hi eventMouseEnter')}
        };
        //console.log(event.date +" |$| "+event.title);
        events.push(event);
        this.calendarEvents = events;
        //console.log("calendarEvents.length = "+this.calendarEvents.length);
      });
    });
  }

  handleDateClick(arg) {
    // handler method
    this.log.d("hi", "arg");
    alert(arg.dateStr);
  }

  setCalendarTimeSlot() {
    this.bookingService.getBookingTimeSlot().subscribe((data) => {
      if (data.length > 0) {
        this.calendarMinTime = data[0].bookingTime;

        let max = data[data.length - 1].bookingTime.split(":");
        this.calendarMaxTime = this.ConvertMaxTime(max);

        console.log("calendarMinTime:" + this.calendarMinTime);
        console.log("calendarMaxTime:" + this.calendarMaxTime);
      }
    });
  }

  ConvertMaxTime(max: String[]) {
    const TimeEventDuration = "30";

    if (max[1] == TimeEventDuration) {
      max[1] = "00";
      max[0] = String(Number(max[0]) + 1);
    } else if (max[1] == "00") {
      max[1] = TimeEventDuration;
    } else {
      console.error("The duration is " + TimeEventDuration + " minutes");
    }

    return max[0] + ":" + max[1];
  }

  isBookingFull(people: number) {
    // dataJson.
    return people > this.bookingTimeSlot_max_limit ? "#dc3545" : "#3b5998";
  }

  close() {
    this.log.i(this.TAG, "do close");
    this.activeModal.close();
  }
}
